import { useSelector } from "react-redux";

import { COLORS } from "../../../../../theme/colors";
import { nFormatter, currencyFormatter } from "../../../../../services/utils";

export const EmissionReductionLabel = ({ x, y, width, value }) => {
  return (
    <>
      <text
        x={x + width / 2}
        y={y - 10}
        fill={COLORS.darks[0][100]}
        fontWeight="bold"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        {nFormatter(value)} KgCo2
      </text>
    </>
  );
};

export const CarboonRevenueLabel = ({ x, y, width, value }) => {
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  return (
    <>
      <text
        x={x + width / 2}
        y={y - 10}
        fill={COLORS.darks[0][100]}
        fontWeight="bold"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        {currencyFormatter(value, currencySymbol)}
      </text>
    </>
  );
};
